import type { OfferUnavailableLogReason } from '../types';
import {
  OFFER_NOT_STARTED_REFUSED_REASON,
  OFFER_REFUSED_REASON,
  OFFER_SOLD_OUT_REFUSED_REASON,
  type OfferUnavailableReason,
} from './offerUnavailableRoute';

// FIN-8016 (C4): erro do POST /v3/payment quando a oferta encerrou.
// FIN-8011 (decisão 14): PLAN_SALES_NOT_STARTED quando as vendas não abriram.
// FIN-8119: PLAN_SOLD_OUT com o produto esgotado; SALES_COUNT_UNAVAILABLE
// quando o BFF não tem a contagem (falha técnica, nunca fala em esgotado).
export const OFFER_REFUSAL_CODES = [
  'PLAN_SALES_CLOSED',
  'PLAN_SALES_NOT_STARTED',
  'PLAN_SOLD_OUT',
  'SALES_COUNT_UNAVAILABLE',
] as const;

export type OfferRefusalCode = (typeof OFFER_REFUSAL_CODES)[number];

export function isOfferRefusalCode(code: unknown): code is OfferRefusalCode {
  return (OFFER_REFUSAL_CODES as readonly unknown[]).includes(code);
}

export function getOfferRefusalCode(error: unknown): OfferRefusalCode | null {
  const messageCode = (
    error as { response?: { data?: { messageCode?: unknown } } }
  )?.response?.data?.messageCode;

  return isOfferRefusalCode(messageCode) ? messageCode : null;
}

export function toOfferLogReason(
  code: OfferRefusalCode
): OfferUnavailableLogReason {
  switch (code) {
    case 'PLAN_SALES_NOT_STARTED':
      return 'not_started';
    case 'PLAN_SOLD_OUT':
      return 'sold_out';
    case 'SALES_COUNT_UNAVAILABLE':
      return 'sales_count_unavailable';
    default:
      return 'expired';
  }
}

/**
 * Variação da página de pagamento recusado para cada código de recusa.
 * `undefined` = variação genérica (SALES_COUNT_UNAVAILABLE, FIN-8119).
 */
export function toOfferRefusedReason(
  code: OfferRefusalCode
): OfferUnavailableReason | undefined {
  switch (code) {
    case 'PLAN_SALES_NOT_STARTED':
      return OFFER_NOT_STARTED_REFUSED_REASON;
    case 'PLAN_SOLD_OUT':
      return OFFER_SOLD_OUT_REFUSED_REASON;
    case 'SALES_COUNT_UNAVAILABLE':
      return undefined;
    default:
      return OFFER_REFUSED_REASON;
  }
}
